<template>
    <div id="account-home-phone-popover-container">
        <f7-popover :id="popoverDropdown" :class="'popover-'+name+' mobile-country-code account'" :backdrop="true">
            <f7-searchbar :id="searchbarId" search-container=".country-code-list" search-in=".country-name" @searchbar:search="onSearch"></f7-searchbar>
            <f7-list class="searchbar-not-found">
                <f7-list-item :title="$t('beneficiary-no-found')"></f7-list-item>
            </f7-list>
            <f7-list class="country-code-list">
                <f7-list-item popover-close link="#"
                v-for="item in countryList"
                :key="item.countryId"
                :selected="mobileCountryId"
                @click="changeMobilePhoneCode(item)">
                    <img :src="getFlagImg(item.countryId)" class="mr-sm"/>
                    <span class="country-name">{{item.countryName+" "+item.countryIDD}}</span>
                </f7-list-item>
            </f7-list>
        </f7-popover>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
    props: {
        name: String,
        countryList: Array,
        mobileCountryId: Number,
        popoverDropdown: String,
        searchbarId: String,
        linkId: String,
    },
    mounted (){
        this.init()
    },
    data: function () {
        return {
            
        }
    },
    computed: {
      ...mapGetters('misc', [
          'latestCountryCodePopoverDirection',
        ])
    },
    methods: {
        init() {
            const self    = this;

            /* POPOVER HOME NO */
            self.Dom7('.popover-home-no').on('popover:open', function () {
                self.$$(".popover-home-no").css({
                    'visibility' : 'hidden',
                });
            });

            self.Dom7('.popover-home-no').on('popover:opened', function () {
                var thepopover = self.Dom7('.popover-home-no');
                const classes = thepopover[0].firstChild.classList;
                const popoverDirection = classes[1];

                const parentPosTop = document.getElementById('homeNo').getBoundingClientRect().top;
                const parentPosBottom = document.getElementById('homeNo').getBoundingClientRect().bottom;
                const parentPosLeft = document.getElementById('homeNo').getBoundingClientRect().left;
                var eleHeight = document.querySelector('.popover-home-no .popover-inner').offsetHeight;

                if(popoverDirection == "on-top"){
                console.log("popover direction: bottom");
                self.$$(".popover-home-no").css({
                    'visibility' : 'visible',
                    'top' : (parentPosBottom-8) + 'px',
                });
                }else if(popoverDirection == "on-bottom"){
                console.log("popover direction: top");
                self.$$(".popover-home-no").css({
                    'visibility' : 'visible',
                    'margin-top' : (8) + 'px',
                });
                }else if(popoverDirection == "on-left"){
                console.log("force direction to top");
                console.log("popover direction: left");              
                self.$$(".popover-home-no").css({ // force direction to top
                    'visibility' : 'visible',
                    'top' : (parentPosTop - eleHeight + 8) + 'px',
                    'left': (24) + 'px'
                });
                }else if(popoverDirection == "on-right"){
                console.log("force direction to top");
                console.log("popover direction: right");            
                self.$$(".popover-home-no").css({ // force direction to top
                    'visibility' : 'visible',
                    'top' : (parentPosTop - eleHeight + 8) + 'px', /* 8 = padding left of dropdown */
                    'left'  : (parentPosLeft - 100 - 8) + 'px' /* 100 = country code width, 8 = padding left of dropdown */
                });
                }
            });
            /* END OF POPOVER HOME NO */
        },

        changeMobilePhoneCode(item){
            this.$emit("changeMobilePhoneCode", item);
        },

        onSearch(){
            const self    = this;
            if(self.latestCountryCodePopoverDirection == "above"){
                if(self.searchbarId == "accMobileCountryCodeSearch"){
                    const popover = ".account.popover-mobileNo";
                    const popoverInner = ".account.popover-mobileNo .popover-inner";
                    const popoverId = "accountMobileNoDropdown";
                    const inputId = "mobileNo";
                    const inputListId = "#mobileNoListId";

                    self.setPopoverPosition(popover, popoverInner, popoverId, inputId, inputListId, "mobile-input", self.linkId, "accMobileCountryCodeSearch", true)

                }else if(self.searchbarId == "accNewMobileCountryCodeSearch"){
                    const popover2 = ".account.popover-newMobileNo";
                    const popoverInner2 = ".account.popover-newMobileNo .popover-inner";
                    const popoverId2 = "accountNewMobileNoDropdown";
                    const inputId2 = "newMobileNo";
                    const inputListId2 = "#newMobileNoListId";

                    self.setPopoverPosition(popover2, popoverInner2, popoverId2, inputId2, inputListId2, "mobile-input", self.linkId, "accNewMobileCountryCodeSearch", true)
                }
                
            }
        }
    }
  }
</script>